import { segment } from '@actions/analytics';
import { noOp } from '@constants/empty';
import { PLANNER_DEBUG } from '@constants/segment';
import { getHeartbeat } from '@cont/PlannerV2/planner-utils/diagnostics/PlannerHeartbeat';
import getPlannerWorker from '@cont/PlannerV2/planner-utils/worker';
import { useCallback, useEffect } from 'react';

let mainWorkerInstance = null;
const workerHandlerMap = new Map();

/**
 * Creates and uses worker for planner hook
 */
const usePlannerWorker = () => {
  useEffect(() => {
    if (!mainWorkerInstance) {
      const worker = getPlannerWorker();
      if (!worker) {
        segment.track(PLANNER_DEBUG, { noWorker: true });
      }
      worker.addEventListener('message', (event) => {
        const { type } = event.data;
        if (type.startsWith('PH_')) {
          getHeartbeat().handleEvent(type, event.data);
        } else {
          const operation = workerHandlerMap.get(type) || noOp;
          operation(event.data);
        }
      });
      mainWorkerInstance = worker;
    }
  }, []);

  const attachListeners = useCallback((eventHandlerMap) => {
    if (eventHandlerMap) {
      Object.entries(eventHandlerMap).forEach(([eventName, handler]) => {
        workerHandlerMap.set(eventName, handler);
      });
    }
  }, []);

  const detachListeners = useCallback((eventList = []) => {
    if (eventList?.length > 0) {
      eventList.forEach((eventName) => {
        if (workerHandlerMap.has(eventName)) {
          workerHandlerMap.delete(eventName);
        }
      });
    }
  }, []);

  return {
    mainWorkerInstance,
    attachListeners,
    detachListeners
  };
};

export default usePlannerWorker;
